module.exports = __webpack_public_path__ + "static/media/uv.9953852c.svg";